import React from "react";

import { t } from "i18next";

import { useHomeNavigation } from "@/hooks/useHomeNavigation";

import { SearchBar } from "@/components/atoms";

import {
	VIEW_SEARCH_GROUP,
	PROJECT_SEARCH_GROUP,
	TASK_SEARCH_GROUP,
} from "@/constants/CSearch";

import {
	TViewSearchResultOptions,
	TProjectSearchResultOptions,
	TSelectedSearchOption,
	TTaskSearchResult,
} from "@/types";

export const HeaderSearch: React.FC = () => {
	const { toTask, toProject, toView } = useHomeNavigation();

	// A hit filters the home page (this bar lives there): the task in its
	// panel - the panel moves the period to its days; a project as the
	// list's filter, a view as the page itself. The search page sends the
	// same hits to their management pages instead.
	const handleSelect = (_value: unknown) => {
		const value = _value as TSelectedSearchOption;
		if (value?.group === TASK_SEARCH_GROUP) {
			const task = value as TTaskSearchResult;
			return toTask(task.id);
		}
		if (value?.group === PROJECT_SEARCH_GROUP) {
			const project = value as TProjectSearchResultOptions;
			return toProject(project.id);
		}
		if (value?.group === VIEW_SEARCH_GROUP)
			return toView((value as TViewSearchResultOptions).id);
	};

	return (
		<div data-header-search className="w-full min-w-40 md:max-w-100">
			<SearchBar
				placeholder={t("search.placeholder")}
				onSelect={handleSelect}
			/>
		</div>
	);
};
